"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiLanguageStructureWarningProvider = void 0;
class MultiLanguageStructureWarningProvider {
    static getUserConfirmation() {
        if (!MultiLanguageStructureWarningProvider.isWarningComponentMounted()) {
            return Promise.resolve(true);
        }
        return new Promise((resolve) => {
            const confirmationListener = () => {
                window.globalEventBus.off(MultiLanguageStructureWarningProvider.events.CANCEL, cancellationListener);
                resolve(true);
            };
            const cancellationListener = () => {
                window.globalEventBus.off(MultiLanguageStructureWarningProvider.events.CONFIRM, confirmationListener);
                resolve(false);
            };
            window.globalEventBus.once(MultiLanguageStructureWarningProvider.events.CONFIRM, confirmationListener);
            window.globalEventBus.once(MultiLanguageStructureWarningProvider.events.CANCEL, cancellationListener);
            window.globalEventBus.emit(MultiLanguageStructureWarningProvider.events.SHOW);
        });
    }
    static confirm() {
        window.globalEventBus.emit(MultiLanguageStructureWarningProvider.events.CONFIRM);
    }
    static cancel() {
        window.globalEventBus.emit(MultiLanguageStructureWarningProvider.events.CANCEL);
    }
    static mount(onShow) {
        this.insureWarningComponentGlobalObject();
        window.materialEditorWarnings.multiLanguageStructure.mounted = true;
        MultiLanguageStructureWarningProvider.onShowWarning = onShow;
        window.globalEventBus.on(MultiLanguageStructureWarningProvider.events.SHOW, onShow);
    }
    static unmount() {
        this.insureWarningComponentGlobalObject();
        window.materialEditorWarnings.multiLanguageStructure.mounted = false;
        window.globalEventBus.off(MultiLanguageStructureWarningProvider.events.SHOW, MultiLanguageStructureWarningProvider.onShowWarning);
        MultiLanguageStructureWarningProvider.onShowWarning = null;
    }
    static isWarningComponentMounted() {
        this.insureWarningComponentGlobalObject();
        return window.materialEditorWarnings.multiLanguageStructure.mounted;
    }
    static insureWarningComponentGlobalObject() {
        window.materialEditorWarnings = window.materialEditorWarnings || {};
        window.materialEditorWarnings.multiLanguageStructure =
            window.materialEditorWarnings.multiLanguageStructure || { mounted: false };
    }
}
exports.MultiLanguageStructureWarningProvider = MultiLanguageStructureWarningProvider;
MultiLanguageStructureWarningProvider.events = {
    SHOW: 'show-multi-language-course-structure-warning',
    CONFIRM: 'confirm-multi-language-course-structure-warning',
    CANCEL: 'cancel-multi-language-course-structure-warning'
};
